export const bugsnagRedactedKeys: Array<string | RegExp> = [
  /authorization/i,
  /cookie/i,
  /password/i,
  /token/i,
  /secret/i,
  /api[-_]?key/i,
  /stripe/i,
  /snipcart/i,
  /recaptcha/i,
  /email/i,
  /phone/i,
  /address/i,
  /payment/i,
  /customer/i,
];

export function getBugsnagReleaseStage(value: string | undefined) {
  const releaseStage = value?.trim() || process.env.NODE_ENV || "development";
  return releaseStage.toLowerCase();
}

export function getBugsnagEnabledReleaseStages(value: string | undefined) {
  const configuredValue = value?.trim() || "staging,production";
  return configuredValue
    .split(",")
    .map((stage) => stage.trim().toLowerCase())
    .filter(Boolean);
}

export function getBugsnagAppVersion(value: string | undefined) {
  return (
    value?.trim() ||
    process.env.NEXT_PUBLIC_BUGSNAG_APP_VERSION?.trim() ||
    process.env.BUGSNAG_APP_VERSION?.trim() ||
    process.env.GITHUB_SHA?.trim() ||
    process.env.WEBSITE_DEPLOYMENT_ID?.trim() ||
    undefined
  );
}

function firstNonEmpty(...values: Array<string | undefined>) {
  for (const value of values) {
    const trimmedValue = value?.trim();
    if (trimmedValue) {
      return trimmedValue;
    }
  }

  return undefined;
}

export function getStorefrontBugsnagApiKey(siteCode: string | null | undefined) {
  const normalizedSiteCode = siteCode?.trim().toLowerCase();

  if (normalizedSiteCode === "asorockfrozen") {
    return firstNonEmpty(
      process.env.BUGSNAG_ASOROCKFROZEN_API_KEY,
      process.env.BUGSNAG_FROZEN_STOREFRONT_API_KEY,
      process.env.STAGING_BUGSNAG_STOREFRONT_FROZEN_API_KEY,
    );
  }

  if (normalizedSiteCode === "asorockfood") {
    return firstNonEmpty(
      process.env.BUGSNAG_ASOROCKFOOD_API_KEY,
      process.env.BUGSNAG_FOOD_STOREFRONT_API_KEY,
      process.env.STAGING_BUGSNAG_STOREFRONT_FOOD_API_KEY,
    );
  }

  return undefined;
}

export function getBugsnagStorefrontRuntimeApiKey(
  siteCode: string | null | undefined,
) {
  return firstNonEmpty(
    getStorefrontBugsnagApiKey(siteCode),
    process.env.BUGSNAG_STOREFRONT_API_KEY,
    process.env.STAGING_BUGSNAG_STOREFRONT_API_KEY,
    process.env.NEXT_PUBLIC_BUGSNAG_API_KEY,
    process.env.BUGSNAG_API_KEY,
  );
}
